import apiClient from 'apiClient/index';
import { loadAllChunks } from 'petdna-lib-uicomponents/helpers';
import {
  TLibUIComponentsUseCMSQuery,
  UseCMSQueryResponse,
} from 'petdna-lib-uicomponents/types';
import { useEffect, useState } from 'react';

const { hygraphApiEndpoint, hygraphAxiosInstance } = apiClient.hygraph;

const batchSize = 100;

export const useCMSQuery: TLibUIComponentsUseCMSQuery = <
  VT extends Record<string, unknown>,
  RT extends unknown,
>(
    query: string,
    variables?: VT,
    getChunkCount?: (res: RT) => number,
    chucksReduceMap?: (acc: RT, chunk: RT) => RT,
  ): UseCMSQueryResponse<RT> => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState<RT>();

  useEffect(() => {
    let current = true;

    setLoading(true);

    if (getChunkCount && chucksReduceMap) {
      loadAllChunks(
        batchSize,
        (params) => hygraphAxiosInstance
          .post<{ data: RT }>(
          hygraphApiEndpoint,
          JSON.stringify({ query, variables: { ...variables, ...params } }),
        ).then((d) => d.data.data),
        getChunkCount,
      )
        .then((chunks) => {
          if (!current) {
            return;
          }
          setResponse(chunks.reduce(chucksReduceMap));
          setLoading(false);
        })
        .catch((err) => {
          if (!current) {
            return;
          }

          console.error(err);
          setLoading(false);
          setResponse(undefined);
        });
    } else {
      hygraphAxiosInstance
        .post<{ data: RT }>(
        hygraphApiEndpoint,
        JSON.stringify({ query, variables }),
      )
        .then(({ data }) => {
          if (!current) {
            return;
          }

          setResponse(data.data);
          setLoading(false);
        })
        .catch((err) => {
          if (!current) {
            return;
          }

          console.error(err);
          setLoading(false);
          setResponse(undefined);
        });
    }

    return () => {
      current = false;
    };
  }, [query, variables, getChunkCount, chucksReduceMap]);

  return {
    loading,
    response,
  };
};
